import React, { Component } from 'react';
import { connect } from "react-redux";
import { isConsole, isMobile } from 'react-device-detect';
import className from 'classnames';

import './manager.css';
import managerService from '../../service/ManagerService';
import step from '../../config/Step';
import Loader from '../loader/Loader';
import ErrorModal from '../../components/modal_error/ErrorModal';
import errorsInfo from '../../config/staticErrorMessage';
import config from '../../config/config';
import Tab from '../../components/tab/Tab';
import Header from '../header/Header';
import { ReactComponent as DocumentIcon } from '../../resources/images/document-new.svg';
import { ReactComponent as SignatureIcon } from '../../resources/images/signature-new.svg';
import {Button, Image} from 'react-bootstrap';

import {
    setCode,
    setComponent,
    setName,
    setRut,
    setToken,
    setStepInfo,
    setStepData,
    resetAllData,
    setLoader,
    setErrorType,
    setErrorMessage,
    setErrorData,
    setShowError,
    setExpiration,
    setExpirationSecondsToken,
    setWindowVisibility,
    setMultiple,
    setPasswordType,
    setCompanyLogo,
    setSource,
    setIdentityType,
    setDocuments,
    setImage,
    setData,
    setModalButton,
    setPlate,
    setTab,
} from "../../redux/actionCreators";

const { errors: staticErrorMessage, isNewStyleError } = errorsInfo;

class Manager extends Component {

    //Components that manage the loader
    MANAGMENT_LOADER_COMPONENT = [step.data.contract.value];
    CAMERA_BUTTON = 1;
    ACCEPT_BUTTON = 2;
    RELOAD_BUTTON = 3;
    AUTOMATED_ADVANCE_TYPE = [
        'FULL_SECURITY',
        'FULL_SECURITY_NOTARY',
        'FULL',
        'DEFAULT_WITH_CIRCULATION_PERMISSION',
        'FULL_SECURITY_NOTARY',
        'FULL_SECURITY_FEA',
        'FULL_FEA',
        'FULL_LEGACY_FEA',
        'FEA_WITH_CIRCULATION_PERMISSION',
        'FULL_QUIZ',
        'ENROLLMENT',
        'FULL_FEA_WITH_AUTOCAPTURE',
    ];
    AUTOMATED_ADVANCE_COMPONENT = [
        'home',
    ];

    STEPS_WITHOUT_HEADER = [ 'handwritten_signature_capture', "capture_identity_card_front_with_framing", "capture_identity_card_back_with_framing", "capture_identity_card_back_with_framing_single", "capture_identity_card_front_with_framing_single"];
    STEPS_WITHOUT_NAV = [ 'handwritten_signature_capture', 'authentication', 'home_without_code', "capture_identity_card_front_with_framing", "capture_identity_card_back_with_framing", "capture_identity_card_back_with_framing_single", "capture_identity_card_front_with_framing_single"];

    DOCUMENT_REVIEW_COMPONENT = 'document_review';

    SIGNATURE_PROCESS_TAB_SELECTED = 0;
    DOCUMENT_REVIEW_TAB_SELECTED =  1;

    constructor(props) {
        super(props);
        this.code = this.props.match && this.props.match.params && this.props.match.params.code;
        this.review = this.props.match && this.props.match.params && this.props.match.params.review;
        this.props.setComponent(step.data['home_without_code'].value);
        this.props.setCode(this.code);
        this.init(this.code);

        this.selectComponent = this.selectComponent.bind(this);
        this.getMessageFinal = this.getMessageFinal.bind(this);
        this.saveError = this.saveError.bind(this);
    }

    login = async (code, password) => {
        this.props.setLoader(true);
        await this.initProcess(code, password);
    };

    init = async (code) => {
        if (code === 'testing' && config.view_testing) {
            this.props.setComponent('testing');
            this.props.setLoader('false');
            //The case is considered to show the results of previous processes
        } else if (this.review === 'review') {
            this.props.setComponent(step.data['result_process'].value);
            const dataToResult = await managerService.getAllDataToResult(code);
            this.props.setStepInfo({
                externData: dataToResult['EXTERN_DATA'],
                isOnlyView: true
            });
            this.props.setStepData(dataToResult);
            this.props.setLoader(false);
        } else {
            await this.initProcess(code);
        }
    };

    initProcess = async (code, password) => {
        const extraParams = {
            tokenUAF: new URLSearchParams(this.props.location.search).get('tokenUAF'),
            advanceStep: new URLSearchParams(this.props.location.search).get('advanceStep'),
        }
        let showLoader = false;
        const response = await managerService.initProcess(code, password);
        if (response.status === managerService.SUCCESS_RESPONSE) {
            if (response.component !== undefined) {
                this.props.setCompanyLogo(response.companyLogo)
                if (code && !response.canInitDesktop && !isMobile) {
                    this.props.setCode('');
                    this.props.setComponent(step.data['home_without_code'].value);
                    this.props.setErrorType('notAccessDesktop');
                    this.props.setShowError(true);
                } else {
                    this.props.setToken(response.token);
                    this.props.setName(response.name);
                    this.props.setRut(response.rut);
                    this.props.setDocuments(response.documents);
                    this.props.setPasswordType(response.passwordType);
                    this.props.setExpirationSecondsToken(response.expirationSecondsToken);
                    this.props.setExpiration(new Date(response.expiration));
                    this.props.setComponent(response.component);
                    this.props.setSource(response.source);
                    this.props.setIdentityType(response.identityType);
                    this.props.setPlate(response.plate);
                    
                    const contractResumeInfo = response.contractResumeInfo;
                    const company_id = response.company_id;
                    this.props.setStepInfo({ company_id, contractResumeInfo});

                    if (extraParams && (extraParams.tokenUAF === code || extraParams.advanceStep === code)
                        && this.AUTOMATED_ADVANCE_COMPONENT.includes(response.component)
                        && this.AUTOMATED_ADVANCE_TYPE.includes(response.identityType && response.identityType.toUpperCase())
                    ) {
                        this.startAction();
                        showLoader = true;
                    }
                    if (response.multiple) {
                        this.props.setMultiple({ plates: response.plates });
                    }
                    if (response.errorLogin) {
                        this.props.setErrorType('authentication');
                        this.props.setShowError(true);
                    }
                }
            } else {
                this.props.setComponent(step.data['home_without_code'].value);
            }
        } else {
            if (response.data && response.data.message) {
                this.props.setErrorMessage(response.data.message);
                if (response.data.errorData) {
                    this.props.setErrorData(response.data.errorData);
                }
                this.props.setComponent(step.data['home_without_code'].value);
                this.props.setShowError(true);
            } else {
                this.props.setComponent(step.data['home_without_code'].value);
                this.props.setErrorType('login');
                this.props.setShowError(true);
            }
        }
        this.props.setLoader(showLoader);
    };

    getMessageFinal() {
        const errorType = this.props.errorType;
        const isErrorAutocapture = /^AUTOCAPTURE_/i.test(errorType);
        const isErrorLiveness = /^LIVENESS_/i.test(errorType);
        
        const existsErrorsTocService = isErrorAutocapture || isErrorLiveness; 
        const isCodeNotControlled = existsErrorsTocService && !this.props.errorMessage && !staticErrorMessage[errorType];

        if (isCodeNotControlled) {
            staticErrorMessage['codeNotControlled'].code = errorType.match(/_(.*$)/i)[1].trim();
            staticErrorMessage['codeNotControlled'].errorKey = errorType;
            return staticErrorMessage['codeNotControlled'];
        }

        return this.props.errorMessage || staticErrorMessage[errorType] || staticErrorMessage['default'];
    }

    saveError = async (errorMessage) => {
        if(errorMessage.hasOwnProperty("reportToBack") && errorMessage.reportToBack) {
            let processCode = this.code;
            let errorCode = Number(errorMessage.code);
            let errorKey = errorMessage.errorKey;
            let errorDescription = errorMessage.codeNotControlledMessage || '';
            await managerService.saveError(processCode, errorCode, errorKey, errorDescription);
        }
    }

    componentDidUpdate(prevProps) {
        if(this.props.showError && this.props.showError !== prevProps.showError) {
            const errorMessage = this.getMessageFinal();
            if (errorMessage) {
                this.saveError(errorMessage);
            }
        }
    }

    componentDidMount() {
        const hidden = 'hidden';
        const visibilityChange = 'visibilitychange';
        if (typeof document.addEventListener !== "undefined") {
            document.addEventListener(visibilityChange, () => {
                this.props.setWindowVisibility(!document[hidden]);
            }, false);
        }

        this.props.history.listen((location, action) => {
            if (this.props.code !== undefined) {
                this.init(this.props.code);
            }
        });
    }

    nextStep = async () => {
        this.props.setLoader(true);
        this.props.setErrorMessage('');
        const image = step.data[this.props.component].getData(this.props.image);
        const data = step.data[this.props.component].getData(this.props.data);
        const response = await managerService.stepManager(this.props.code, this.props.token, 'next', {...data, ...image});
        if (response.status === managerService.SUCCESS_RESPONSE) {
            if (response.component === managerService.DEFAULT_COMPONENT) {
                this.props.resetAllData();
                this.props.history.push('/');
            } else {
                this.props.setStepInfo(response.info);
                this.props.setStepData(response.data);
                if (response.error) {
                    this.props.setErrorMessage(response.error);
                    this.props.setShowError(true);
                }
                this.props.setComponent(response.component);
            }
        } else {
            if (response.message && response.message.principalMessage) {
                this.props.setErrorMessage(response.message);
            } else {
                //Si el api no retorna el error o no posee el mensaje principal, obtiene la información de los mensajes por defecto
                const auxErrorType = (this.props.component && step.data[this.props.component] && response.message !== 'data') ? step.data[this.props.component].errorType : 'default';
                this.props.setErrorType(auxErrorType);
            }
            this.props.setShowError(true);
        }
        if ((response && !response.redirectUrl) || !response) {
            this.props.setLoader(false);
        }
    };

    accessAction = (event) => {
        event.preventDefault();
        //Loader is finished on init method (componentDidMount() -> init())
        this.props.setLoader(true);
        if (this.props.code !== undefined) {
            const auxCode = (this.props.code).replace('/', '');
            this.props.setCode(auxCode);
            this.props.history.push(`/${auxCode}`);
        } else {
            this.props.setLoader(false);
            this.props.setErrorType('login');
            this.props.setShowError(true);
        }
    };

    startAction = async (event) => {
        this.props.setLoader(true);
        const origin =  new URLSearchParams(this.props.location.search).get('origin') || '';
        const response = await managerService.stepManager(this.props.code, this.props.token, '', {}, { origin });
        if (response.status === managerService.SUCCESS_RESPONSE) {
            this.props.setStepInfo(response.info);
            this.props.setStepData(response.data);
            if (response.error) {
                this.props.setErrorMessage(response.error);
                this.props.setShowError(true);
                if(response && response.info && response.info.isModalButton){
                    this.props.setModalButton(true);
                }
            }
            this.props.setComponent(response.component);
        } else {
            this.props.setErrorType('login');
            this.props.setShowError(true);
        }

        if (!this.MANAGMENT_LOADER_COMPONENT.includes(this.props.component)) {
            this.props.setLoader(false);
        }

    };

    selectComponent = (component) => {
        const actions = {
            'login': this.login,
            'start': this.startAction,
            'next': this.nextStep,
            'access': this.accessAction,
        };
        return step.data[component].component(actions);
    };

    documentType = () => this.props.source === 'DOCUMENT' ? 'Documento' : 'Contrato';

    navTabs(){
        const defaultColor = '#262626';
        const selectedColor = '#701A82';
        const isTabSelected = (number) => this.props.tab === number ? selectedColor : defaultColor; 
        return [
            { 
              title: <div><SignatureIcon fill={isTabSelected(this.SIGNATURE_PROCESS_TAB_SELECTED)} className='tabs-icon'/>Proceso Firma</div>, 
              content: this.selectComponent(this.props.component)
            },
            { 
              title: <div><DocumentIcon fill={isTabSelected(this.DOCUMENT_REVIEW_TAB_SELECTED)} className='tabs-icon'/>Revisar {this.documentType()}</div>, 
              content: this.selectComponent(this.DOCUMENT_REVIEW_COMPONENT) 
            },
          ];
    }


    //Render index app
    render() {
        let errorMessageFinal = this.getMessageFinal();
        return (
            <div>
                <Loader />
                <ErrorModal
                    title={errorMessageFinal.title || 'Error'}
                    icon={errorMessageFinal.icon || ''}
                    principalMessage={errorMessageFinal.principalMessage || ''}
                    secondaryMessage={errorMessageFinal.secondaryMessage || ''}
                    tips={errorMessageFinal.errorTips || []}
                    button={errorMessageFinal.button || this.RELOAD_BUTTON}
                    textButton={errorMessageFinal.textButton || null}
                    customClass={className(errorMessageFinal.customClass || '', {
                        'new-type-error': isNewStyleError(this.props.errorType) 
                    })}
                />
                {this.STEPS_WITHOUT_HEADER.includes(this.props.component) ? this.selectComponent(this.props.component)  :
                   <React.Fragment> 
                        <Header  
                            rut={this.props.rut !== null ? this.props.rut : ''} 
                            plate={this.props.plate !== null ? this.props.plate : ''}
                            componentName={this.props.component}
                        />
                        {this.STEPS_WITHOUT_NAV.includes(this.props.component) ? this.selectComponent(this.props.component)  :
                        <Tab tabs={this.navTabs()}/>
                        }
                    </React.Fragment> 
                }
            </div>
        );

    }
}

const mapStateToProps = state => {
    return {
        code: state.code,
        name: state.name,
        rut: state.rut,
        token: state.token,
        component: state.component,
        stepInfo: state.stepInfo,
        image: state.image,
        stepData: state.stepData,
        loader: state.loader,
        errorType: state.errorType,
        errorMessage: state.errorMessage,
        showError: state.showError,
        multiple: state.multiple,
        passwordType: state.passwordType,
        companyLogo: state.companyLogo,
        source: state.source,
        identityType: state.identityType,
        documents: state.documents,
        data: state.data,
        modalButton: state.modalButton,
        plate: state.plate,
        tab: state.tab
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setPasswordType(passwordType) {
            dispatch(setPasswordType(passwordType));
        },
        setCode(code) {
            dispatch(setCode(code));
        },
        setComponent(component) {
            dispatch(setComponent(component));
        },
        setName(name) {
            dispatch(setName(name));
        },
        setRut(rut) {
            dispatch(setRut(rut));
        },
        setToken(token) {
            dispatch(setToken(token));
        },
        setStepInfo(info) {
            dispatch(setStepInfo(info));
        },
        setStepData(stepData) {
            dispatch(setStepData(stepData));
        },
        resetAllData() {
            dispatch(resetAllData());
        },
        setLoader(loader) {
            dispatch(setLoader(loader));
        },
        setErrorType(errorType) {
            dispatch(setErrorType(errorType));
        },
        setErrorMessage(errorMessage) {
            dispatch(setErrorMessage(errorMessage))
        },
        setErrorData(errorData) {
            dispatch(setErrorData(errorData))
        },
        setShowError(showError) {
            dispatch(setShowError(showError));
        },
        setExpiration(expiration) {
            dispatch(setExpiration(expiration));
        },
        setExpirationSecondsToken(expirationSecondsToken) {
            dispatch(setExpirationSecondsToken(expirationSecondsToken));
        },
        setWindowVisibility(windowVisibility) {
            dispatch(setWindowVisibility(windowVisibility));
        },
        setMultiple(multiple) {
            dispatch(setMultiple(multiple));
        },
        setCompanyLogo(companyLogo) {
            dispatch(setCompanyLogo(companyLogo));
        },
        setSource(source) {
            dispatch(setSource(source));
        },
        setIdentityType(identityType) {
            dispatch(setIdentityType(identityType));
        },
        setDocuments(documents) {
            dispatch(setDocuments(documents));
        },
        setImage(image) {
            dispatch(setImage(image));
        },
        setData(data) {
            dispatch(setData(data));
        },
        setModalButton(modalButton) {
            dispatch(setModalButton(modalButton));
        },
        setPlate(plate){
            dispatch(setPlate(plate));
        },
        setTab(tab){
            dispatch(setTab(tab));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Manager);
